import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LookupFinderComponent } from '../lookup-finder/lookup-finder.component';
import { AuthService } from '../../service/auth-service/auth-service.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'child-modal',
  templateUrl: './modal-content.component.html',
  styleUrls: ['./modal-content.component.css']
})

export class ModalContentComponent implements OnInit {
  @Input() message!: any;
  @ViewChild('app_lookup_finder') lookup_finder!: LookupFinderComponent;
  datasource: any[] = [];
  selectedCode!: string;
  selectedName!: string;
  selectedItems!: string;
  resolutionMode!: number;
  isRemote: boolean = true;

  constructor(public bsModalRef: BsModalRef, private authService: AuthService) { }
  ngOnInit(): void {
    this.authService.getSessionExpired().pipe(
      filter(event => event !== "" && event != null)).
      subscribe(
        event => { this.bsModalRef.hide(); }
      );
  }

  select(event: any) {
    let key = "selectedCode";
    if (this.lookup_finder && this.lookup_finder.lookup && this.lookup_finder.lookup.result) {
      key = this.lookup_finder.lookup.result
    }
    if (Array.isArray(event)) {
      if (event.length === 1) {
        this.selectedCode = event[0][key];
        this.selectedName = event[0].selectedName;
      } else {
        this.selectedItems = event.map(element => element[key]).join('|');
      }
    } else {
      this.selectedCode = event[key];
      this.selectedName = event.selectedName;
    }
    this.resolutionMode = this.isTabActive("local") ? 1 : 2;
    this.bsModalRef.hide();
  }

  modeChanged(event: any) {
    this.isRemote = event;
  }

  isTabActive(tab: string): boolean {
    return (tab == "remote" && this.isRemote) || (tab == "local" && !this.isRemote);
  }

  onButtonAction(buttonAction: String) {
    switch (buttonAction) {
      case 'selectAll':
        this.lookup_finder.selectAll();
        break;
      case 'loadSelected':
        this.lookup_finder.loadSelected();
        break;
    }
  }

}